import { downloadFile, mapPaginationParamsToServer, format } from "@/shared";

import { mapClientFiltersToServer } from "./mappers/to/mapClientFiltersToServer";

export const exportClients = async (paginationParams, filters) => {
    const fileName = `exported_clients_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("/human/client/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapClientFiltersToServer(filters),
    });
};
